import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Send, CheckCircle, ArrowLeft } from 'lucide-react';
import MainLayout from '../layout/MainLayout';
import { apiService } from '../../services/api';
import './ContactPage.scss';

const ContactPage: React.FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const set = (k: string, v: string) => setForm(prev => ({ ...prev, [k]: v }));

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!form.name.trim() || !form.email.trim() || form.message.trim().length < 10) {
      setError('Completa tu nombre, correo y un mensaje de al menos 10 caracteres.');
      return;
    }
    setSending(true);
    try {
      await apiService.post('/contact', form);
      setSent(true);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'No se pudo enviar el mensaje. Intenta más tarde.');
    } finally {
      setSending(false);
    }
  };

  return (
    <MainLayout>
      <div className="contact-page">
        <button className="contact-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} /> Volver
        </button>

        <div className="contact-grid">
          <div className="contact-intro">
            <div className="eyebrow">Programa de Mentoría · Mitsui</div>
            <h1>Contacto</h1>
            <p>
              ¿Tienes dudas sobre el programa, tu dupla o la plataforma? Escríbenos y el equipo
              de coordinación te responderá.
            </p>
            <a className="contact-mail" href="mailto:no-reply@kuali.ai">
              <Mail size={18} /> no-reply@kuali.ai
            </a>
          </div>

          <div className="contact-card">
            {sent ? (
              <div className="contact-success">
                <CheckCircle size={40} />
                <h3>¡Mensaje enviado!</h3>
                <p>Gracias por escribirnos. Te responderemos pronto.</p>
                <button className="contact-btn" onClick={() => { setSent(false); setForm({ name: '', email: '', subject: '', message: '' }); }}>
                  Enviar otro mensaje
                </button>
              </div>
            ) : (
              <form onSubmit={submit} className="contact-form">
                <label>
                  <span>Nombre *</span>
                  <input type="text" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Tu nombre" />
                </label>
                <label>
                  <span>Correo *</span>
                  <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="tucorreo@ejemplo.com" />
                </label>
                <label>
                  <span>Asunto</span>
                  <input type="text" value={form.subject} onChange={e => set('subject', e.target.value)} placeholder="¿Sobre qué nos escribes?" />
                </label>
                <label>
                  <span>Mensaje *</span>
                  <textarea rows={5} value={form.message} onChange={e => set('message', e.target.value)} placeholder="Cuéntanos en qué te podemos ayudar…" />
                </label>
                {error && <div className="contact-error">{error}</div>}
                <button type="submit" className="contact-btn" disabled={sending}>
                  <Send size={16} /> {sending ? 'Enviando…' : 'Enviar mensaje'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactPage;
